import {
  IdTypes
} from '../../../constants';
import { FieldTypes } from '../../../components/FormBuilder';

export const formInitialValues = {
  identityType: 'id',
  passportNumber: '',
  idNumber: ''
};

export const identityType = {
  placeholder: 'Identity Type',
  name: 'idType',
  options: IdTypes,
  scrollToTop: false
};

export const idTypeFields = {
  id: [
    {
      type: FieldTypes.INPUT,
      props: {
        type: 'text',
        inputMode: 'text',
        name: 'idNumber',
        placeholder: 'South African ID number',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    }
  ],
  sapp: [
    {
      type: FieldTypes.INPUT,
      props: {
        type: 'text',
        inputMode: 'text',
        name: 'passportNumber',
        placeholder: 'South African Passport number',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    }
  ],
  pp: [
    {
      type: FieldTypes.INPUT,
      props: {
        type: 'text',
        inputMode: 'text',
        name: 'passportNumber',
        placeholder: 'Non South African Passport number',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    }
  ]
};

export const formFields = [
  {
    type: FieldTypes.SELECT,
    props: identityType
  },
  {
    type: FieldTypes.DYNAMIC_ID_FIELDS,
    fields: idTypeFields
  }
];
